"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invoiceListResponseSchema = exports.invoiceDetailSchema = exports.invoiceSummarySchema = exports.invoiceVersionSchema = exports.invoiceVersionDocumentSchema = exports.invoiceVersionSummarySchema = exports.paymentSchema = exports.paymentReversalSchema = exports.invoiceActivitySchema = exports.invoiceActivityTypeSchema = exports.invoiceLineSchema = exports.invoiceJobSchema = exports.invoiceRecipientSchema = exports.reversePaymentRequestSchema = exports.recordPaymentRequestSchema = exports.updateInvoiceStatusRequestSchema = exports.updateInvoiceRequestSchema = exports.createInvoiceRequestSchema = exports.paymentSourceSchema = exports.paymentMethodSchema = exports.invoicePaymentTermsSchema = exports.invoiceFinancialStatusSchema = exports.invoiceStatusSchema = exports.paymentIdSchema = exports.invoiceIdSchema = void 0;
const zod_1 = require("zod");
const customer_1 = require("./customer");
const job_1 = require("./job");
const pagination_1 = require("./pagination");
const optionalTrimmedString = (maxLength) => zod_1.z
    .string()
    .trim()
    .max(maxLength)
    .optional()
    .transform((value) => value || undefined);
exports.invoiceIdSchema = zod_1.z.string().uuid();
exports.paymentIdSchema = zod_1.z.string().uuid();
exports.invoiceStatusSchema = zod_1.z.enum(["DRAFT", "OPEN", "VOID"]);
exports.invoiceFinancialStatusSchema = zod_1.z.enum([
    "UNPAID",
    "PARTIALLY_PAID",
    "PAID",
    "PAST_DUE",
]);
exports.invoicePaymentTermsSchema = zod_1.z.enum([
    "DUE_ON_RECEIPT",
    "NET_7",
    "NET_15",
    "NET_30",
    "CUSTOM",
]);
exports.paymentMethodSchema = zod_1.z.enum([
    "CASH",
    "CHECK",
    "CARD",
    "CARD_EXTERNAL",
    "BANK_TRANSFER",
    "OTHER",
]);
exports.paymentSourceSchema = zod_1.z.enum(["MANUAL", "PROVIDER"]);
const invoiceDraftInputSchema = zod_1.z.object({
    recipientContactId: zod_1.z.string().uuid().optional(),
    paymentTerms: exports.invoicePaymentTermsSchema.default("DUE_ON_RECEIPT"),
    dueAt: zod_1.z.string().datetime().optional(),
    notes: optionalTrimmedString(5_000),
});
exports.createInvoiceRequestSchema = invoiceDraftInputSchema.extend({
    jobId: zod_1.z.string().uuid(),
});
exports.updateInvoiceRequestSchema = invoiceDraftInputSchema;
exports.updateInvoiceStatusRequestSchema = zod_1.z.discriminatedUnion("status", [
    zod_1.z.object({ status: zod_1.z.literal("OPEN") }),
    zod_1.z.object({
        status: zod_1.z.literal("VOID"),
        reason: zod_1.z.string().trim().min(2).max(1_000),
    }),
]);
exports.recordPaymentRequestSchema = zod_1.z.object({
    method: exports.paymentMethodSchema,
    amountCents: zod_1.z.number().int().positive(),
    receivedAt: zod_1.z.string().datetime(),
    reference: optionalTrimmedString(160),
    note: optionalTrimmedString(1_000),
    idempotencyKey: zod_1.z.string().trim().min(8).max(160),
});
exports.reversePaymentRequestSchema = zod_1.z.object({
    reason: zod_1.z.string().trim().min(2).max(1_000),
});
exports.invoiceRecipientSchema = zod_1.z.object({
    contactId: zod_1.z.string().uuid().nullable(),
    name: zod_1.z.string(),
    email: zod_1.z.string().email().nullable(),
    phone: zod_1.z.string().nullable(),
    preferredChannel: customer_1.communicationChannelSchema,
    smsConsentStatus: customer_1.smsConsentStatusSchema,
});
exports.invoiceJobSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    jobNumber: zod_1.z.number().int().positive(),
    summary: zod_1.z.string(),
});
exports.invoiceLineSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    sourceJobLineId: zod_1.z.string().uuid(),
    catalogItemId: zod_1.z.string().uuid().nullable(),
    position: zod_1.z.number().int().nonnegative(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    type: zod_1.z.enum(["SERVICE", "MATERIAL"]),
    pricingUnit: zod_1.z.enum(["FLAT_RATE", "HOUR", "EACH"]),
    quantityMilli: zod_1.z.number().int().positive(),
    unitPriceCents: zod_1.z.number().int().nonnegative(),
    taxable: zod_1.z.boolean(),
    lineTotalCents: zod_1.z.number().int().nonnegative(),
    priceBookVersionId: zod_1.z.string().uuid().nullable().optional(),
});
exports.invoiceActivityTypeSchema = zod_1.z.enum([
    "CREATED",
    "UPDATED",
    "ISSUED",
    "DELIVERY_QUEUED",
    "SENT",
    "DELIVERED",
    "DELIVERY_FAILED",
    "PAYMENT_RECORDED",
    "PREPAYMENT_APPLIED",
    "PAYMENT_REVERSED",
    "VOIDED",
]);
exports.invoiceActivitySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: exports.invoiceActivityTypeSchema,
    actorSubject: zod_1.z.string().nullable(),
    actorName: zod_1.z.string().nullable(),
    detail: zod_1.z.string().nullable(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    occurredAt: zod_1.z.string().datetime(),
});
exports.paymentReversalSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    reason: zod_1.z.string(),
    actorSubject: zod_1.z.string(),
    actorName: zod_1.z.string().nullable(),
    reversedAt: zod_1.z.string().datetime(),
});
exports.paymentSchema = zod_1.z.object({
    id: exports.paymentIdSchema,
    method: exports.paymentMethodSchema,
    source: exports.paymentSourceSchema,
    amountCents: zod_1.z.number().int().positive(),
    allocatedAmountCents: zod_1.z.number().int().positive(),
    receivedAt: zod_1.z.string().datetime(),
    reference: zod_1.z.string().nullable(),
    note: zod_1.z.string().nullable(),
    actorSubject: zod_1.z.string(),
    actorName: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string().datetime(),
    reversal: exports.paymentReversalSchema.nullable(),
});
exports.invoiceVersionSummarySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    versionNumber: zod_1.z.number().int().positive(),
    contentHash: zod_1.z.string().length(64),
    createdBySubject: zod_1.z.string(),
    createdByName: zod_1.z.string().nullable(),
    createdAt: zod_1.z.string().datetime(),
});
exports.invoiceVersionDocumentSchema = zod_1.z.object({
    invoiceId: exports.invoiceIdSchema,
    invoiceNumber: zod_1.z.number().int().positive(),
    versionNumber: zod_1.z.number().int().positive(),
    job: exports.invoiceJobSchema,
    customer: job_1.jobCustomerSchema,
    serviceLocation: job_1.jobServiceLocationSchema,
    recipient: exports.invoiceRecipientSchema,
    notes: zod_1.z.string().nullable(),
    paymentTerms: exports.invoicePaymentTermsSchema,
    dueAt: zod_1.z.string().datetime(),
    lines: zod_1.z.array(exports.invoiceLineSchema.omit({ id: true })),
    subtotalCents: zod_1.z.number().int().nonnegative(),
    taxableSubtotalCents: zod_1.z.number().int().nonnegative(),
    taxRateMilliPercent: zod_1.z.number().int().nonnegative(),
    taxCents: zod_1.z.number().int().nonnegative(),
    totalCents: zod_1.z.number().int().nonnegative(),
    issuedAt: zod_1.z.string().datetime(),
});
exports.invoiceVersionSchema = exports.invoiceVersionSummarySchema.extend({
    document: exports.invoiceVersionDocumentSchema,
});
exports.invoiceSummarySchema = zod_1.z.object({
    id: exports.invoiceIdSchema,
    invoiceNumber: zod_1.z.number().int().positive(),
    status: exports.invoiceStatusSchema,
    financialStatus: exports.invoiceFinancialStatusSchema.nullable(),
    job: exports.invoiceJobSchema,
    customer: job_1.jobCustomerSchema,
    serviceLocation: job_1.jobServiceLocationSchema,
    recipient: exports.invoiceRecipientSchema,
    currentVersionNumber: zod_1.z.number().int().nonnegative(),
    paymentTerms: exports.invoicePaymentTermsSchema,
    dueAt: zod_1.z.string().datetime(),
    subtotalCents: zod_1.z.number().int().nonnegative(),
    taxableSubtotalCents: zod_1.z.number().int().nonnegative(),
    taxRateMilliPercent: zod_1.z.number().int().nonnegative(),
    taxCents: zod_1.z.number().int().nonnegative(),
    totalCents: zod_1.z.number().int().nonnegative(),
    amountPaidCents: zod_1.z.number().int().nonnegative(),
    balanceCents: zod_1.z.number().int().nonnegative(),
    issuedAt: zod_1.z.string().datetime().nullable(),
    voidedAt: zod_1.z.string().datetime().nullable(),
    createdAt: zod_1.z.string().datetime(),
    updatedAt: zod_1.z.string().datetime(),
});
exports.invoiceDetailSchema = exports.invoiceSummarySchema.extend({
    notes: zod_1.z.string().nullable(),
    lines: zod_1.z.array(exports.invoiceLineSchema),
    payments: zod_1.z.array(exports.paymentSchema),
    activities: zod_1.z.array(exports.invoiceActivitySchema),
    versions: zod_1.z.array(exports.invoiceVersionSummarySchema),
});
exports.invoiceListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.invoiceSummarySchema),
    total: zod_1.z.number().int().nonnegative(),
    pageInfo: pagination_1.pageInfoSchema.default(pagination_1.defaultPageInfo),
});
//# sourceMappingURL=invoice.js.map